// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10U_R","content":"styles_content__geJ52"};